import {
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import { add, isWithinInterval, sub, subDays } from "date-fns";
import { dateTimeFormatter } from "../helperFunctions/dateFormatters";
import { getWeekBookends } from "../helperFunctions/calendarFunctions";
import React, { useMemo } from "react";
import "../css/calendarControls.scss";

function CalendarControls({ showDate, setShowDate, isCalendar = false }) {
  let [startOfWeek, endOfWeek] = useMemo(
    () => getWeekBookends(showDate),
    [showDate]
  );

  function isTodayWithinCurrentWeek() {
    let todayWithinShownWeek = null;

    try {
      todayWithinShownWeek = isWithinInterval(new Date(), {
        start: startOfWeek,
        end: endOfWeek,
      });
      return todayWithinShownWeek;
    } catch (e) {
      return false;
    }
  }

  function goBackOneWeek() {
    let backOneWeekDate = sub(showDate, { weeks: 1 });
    if (isCalendar) {
      window.sessionStorage.setItem("calendar_date", backOneWeekDate);
    }
    setShowDate(backOneWeekDate);
  }

  function goForwardOneWeek() {
    let forwardOneWeekDate = add(showDate, { weeks: 1 });
    if (isCalendar) {
      window.sessionStorage.setItem("calendar_date", forwardOneWeekDate);
    }
    setShowDate(forwardOneWeekDate);
  }

  let todayInCurrentWeek = isTodayWithinCurrentWeek();

  return (
    <div className="calendar-controls">
      <div className="startAndEndOfWeek">
        <button onClick={goBackOneWeek}>
          <ArrowBackIcon />
        </button>
        <div>
          <p>{dateTimeFormatter(startOfWeek, "d_short")}</p>
          <p className="seperator"> -- </p>
          <p>{dateTimeFormatter(subDays(endOfWeek, 2), "d_short")}</p>
        </div>
        <button onClick={goForwardOneWeek}>
          <ArrowForwardIcon />
        </button>
      </div>

      {!todayInCurrentWeek && (
        <button
          className="today-btn"
          onClick={() => {
            window.sessionStorage.setItem("calendar_date", new Date());
            setShowDate(new Date());
          }}
        >
          Today
        </button>
      )}

      {/* <button
            className="show-weekends-btn"
            onClick={() => setHideWeekends((p) => !p)}
          >
            {hideWeekends ? "Show" : "Hide"} Wk/ends
          </button> */}
    </div>
  );
}

export default React.memo(CalendarControls);
